import React, { useContext } from 'react';
import ICellProps from './ICellProps';
import { BodyCell } from '@creditflowresearch/uilib/Table/DataTable';
import TrancheSizeCell from '@/creditflowresearch/ui/common/components/TableCells/TrancheSizeCell';
import ITranch from '@/creditflowresearch/domain/vo/Tranch/ITranch';
import { IDealStatus } from '@/creditflowresearch/domain/vo/IDeal';
import { IDictionaryDealStatus, IDictionarySizeDescription } from '@/creditflowresearch/domain/vo/IDictionary';
import { DictionariesContext } from '@/creditflowresearch/application/Dictionaries/DictionariesContext';
import { useDictionariesContext } from '@/creditflowresearch/application/Dictionaries/v2/DictionariesContext';

import alignStyles from '@creditflowresearch/uilib/styles/helpers/align.module.scss';

const getCell = (
  tranche: ITranch,
  dealStatus: IDealStatus,
  sizeDescription: IDictionarySizeDescription,
) => (
  <TrancheSizeCell
    size={ tranche.size.size }
    sizeDescription={ sizeDescription }
    status={ dealStatus as IDictionaryDealStatus }
    decimals={ 3 }
  />
);

interface ISizeCellProps extends ICellProps {
  dealStatus: IDealStatus,
}

const SizeCell = ({
  rowIndex,
  tranche,
  dealStatus,
}: ISizeCellProps) => {
  const legacy = useContext(DictionariesContext);
  const { sizeDescriptions: v2SizeDescriptions } = useDictionariesContext();
  const sizeDescriptions = legacy?.sizeDescriptions ?? v2SizeDescriptions;

  return (
    <BodyCell
      name="SizeCell"
      className={ alignStyles.alignRight }
      rowIndex={ rowIndex }
      rowData={ tranche }
      cellCallback={ () => getCell(tranche, dealStatus, sizeDescriptions.getById(tranche.sizeDescriptionId)) }
    />
  );
};

export default SizeCell;
